import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";
import { useToast } from "../hooks/ToastContext";
import axios from "axios";
import config from "../config";

function FeForgot({
  contestDetails,
  // signinEntry,
  inputs,
  setInputs,
  // feSignin,
  clickloginBtn,
  // isRegLoading,
}) {
  // const entrydet = JSON.parse(signinEntry.entry);
  const { showToast } = useToast();
  const [step, setStep] = useState(1);
  // 1 = email, 2 = otp, 3 = reset password
  const [otpData, setOtpData] = useState(null);
  const [isLoadSendOtp, setIsLoadSendOtp] = useState(false);
  const [isLoadVerifyOtp, setIsLoadVerifyOtp] = useState(false);
  const [isLoadResetPwd, setIsLoadResetPwd] = useState(false);

  // const handleChange = (e) => {
  //   setInputs((inputs) => {
  //     // console.log(inputs)
  //     return {
  //       ...inputs,
  //       [e.target.name]: e.target.value,
  //     };
  //   });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setInputs((prev) => {
      return {
        ...prev,
        [name]:
          name === "otp"
            ? value.replace(/\D/g, "").slice(0, 6) // ✅ only numbers + max 6
            : value,
      };
    });
  };

  // send otp
  const handleSendOtp = async () => {
    if (!inputs.email?.trim()) {
      showToast("warning", "Email should not be empty");
      return;
    }

    // ✅ Email Regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(inputs.email)) {
      showToast("warning", "Please enter a valid email address");
      return;
    }

    let payload = {
      email: inputs.email,
      contest_id: contestDetails?.contest?.contest_id,
    };

    setIsLoadSendOtp(true);

    try {
      const res = await axios.post(
        `${config.API_URL}/contest-send-otp`,
        payload,
      );

      if (res.status === 200 && res.data?.success === true) {
        setOtpData(res.data);
        showToast("success", res?.data?.message);
        setStep(2);
      } else {
        showToast("error", res?.data?.message);
      }
    } catch (error) {
      showToast(
        "error",
        error?.response?.data?.message || "Something went wrong",
      );
    } finally {
      setIsLoadSendOtp(false);
    }
  };

  // verify otp
  const handleVerifyOtp = async () => {
    if (!inputs.otp?.trim()) {
      showToast("warning", "OTP should not be empty");
      return;
    }

    let payload = {
      email: inputs.email,
      otp: inputs.otp,
      contest_id: contestDetails?.contest?.contest_id,
      token: otpData?.token,
    };

    setIsLoadVerifyOtp(true);

    try {
      const res = await axios.post(
        `${config.API_URL}/contest-verify-otp`,
        payload,
      );
      if (res.status === 200 && res.data?.success === true) {
        // console.log(res.data);
        showToast("success", res?.data?.message);
        setStep(3);
      } else {
        showToast("error", res?.data?.message);
        // return;
      }
    } catch (error) {
      showToast(
        "error",
        error?.response?.data?.message || "Something went wrong",
      );
    } finally {
      setIsLoadVerifyOtp(false);
    }
  };

  // Reset Password
  const handleResetPwd = async () => {
    if (!inputs.password?.trim()) {
      showToast("warning", "Password should not be empty");
      return;
    }

    if (!inputs.password_confirmation?.trim()) {
      showToast("warning", "Confirm Password should not be empty");
      return;
    }

    if (inputs.password !== inputs.password_confirmation) {
      showToast("warning", "Password and Confirm Password should be same");
      return;
    }

    let payload = {
      email: inputs.email,
      otp: inputs.otp,
      contest_id: contestDetails?.contest?.contest_id,
      token: otpData?.token,
      password: inputs.password,
      password_confirmation: inputs.password_confirmation,
    };

    setIsLoadResetPwd(true);

    try {
      const res = await axios.post(
        `${config.API_URL}/contest-reset-password`,
        payload,
      );
      if (res.status === 200 && res.data?.success === true) {
        console.log(res.data);
        showToast("success", res?.data?.message);
        setTimeout(() => {
          clickloginBtn("login");
        }, 1000);
      } else {
        console.log(res.data?.message);
        showToast("error", res?.data?.message);
        return;
      }
    } catch (error) {
      showToast(
        "error",
        error?.response?.data?.message || "Something went wrong",
      );
    } finally {
      setIsLoadResetPwd(false);
    }
  };

  return (
    <div className="relative flex justify-center items-center md:p-8">
      <div className=" md:mt-[-135px] mt-[-90px] md:pb-3 pb-8">
        <div className="w-[280px] md:w-[648px] bg-white shadow-md rounded-lg opacity-100">
          <div className="primary_light_bgcolor2 bg-[#E1EDF9] p-6 text-center rounded-t-lg">
            <h2 className="text-center text-black md:text-[17px] sm:leading-[20px] sm:text-[12px] font-medium opacity-100 md:mb-2">
              Forgot your password?
            </h2>
            <h4 className="text-[13px] md:p-1 leading-4 text-black/60">
              Enter your registered email address to receive an OTP for password
              reset.
            </h4>
          </div>

          <div className="p-4 md:p-10">
            {/* STEP 1 - EMAIL */}
            {step === 1 && (
              <div className="mb-5">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  Enter Your Email below
                </label>
                <input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  value={inputs?.email || ""}
                  className="bg-white input_focus_primary border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                  placeholder="Enter Your Email"
                />
              </div>
            )}

            {/* STEP 2 - OTP */}
            {step === 2 && (
              <div className="mb-5 text-center">
                <label className="block mb-3 text-sm font-medium text-gray-900">
                  Enter 6 Digit OTP
                </label>

                <input
                  type="text"
                  inputMode="numeric" // 📱 mobile number keypad
                  pattern="[0-9]*"
                  maxLength={6}
                  name="otp"
                  onChange={handleChange}
                  value={inputs?.otp || ""}
                  className="tracking-[10px] text-center bg-white input_focus_primary text-lg border border-gray-300 rounded-lg p-2.5 w-full"
                  placeholder="------"
                />
              </div>
            )}

            {/* STEP 3 - RESET PASSWORD */}
            {step === 3 && (
              <div className="space-y-4">
                <input
                  type="password"
                  name="password"
                  placeholder="New Password"
                  onChange={handleChange}
                  className="bg-white input_focus_primary border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                />

                <input
                  type="password"
                  name="password_confirmation"
                  placeholder="Confirm Password"
                  onChange={handleChange}
                  className="bg-white input_focus_primary border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                />
              </div>
            )}

            {/* BUTTON AREA */}
            <div class="flex items-center justify-between mt-4">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  clickloginBtn("login");
                }}
                class="group relative text-sm flex gap-1 text-gray-600 font-semibold tracking-wide items-center gap-0.5 leading-none"
              >
                <ArrowLeftIcon className="text-gray-800 transition-transform duration-300 group-hover:-translate-x-1 w-4 h-4" />
                Back to Sign In
                <span class="absolute -bottom-0.5 left-0 h-[2px] w-full bg-gray-500 scale-x-0 origin-right transition-transform duration-300 group-hover:scale-x-100"></span>
              </a>
              {step === 1 && (
                <div class="">
                  <button
                    type="button"
                    disabled={isLoadSendOtp || inputs?.email?.length === 0}
                    onClick={handleSendOtp}
                    className="group flex items-center justify-center gap-2 w-full py-1 px-2 rounded-md primary_btn_bg text-white transition-all duration-300 ease-in-out disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    {isLoadSendOtp ? (
                      <>
                        {/* Spinner */}
                        <svg
                          className="animate-spin h-4 w-4"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a12 12 0 00-12 12h4z"
                          ></path>
                        </svg>
                        Sending...
                      </>
                    ) : (
                      <>
                        Send OTP
                        <ArrowRightIcon
                          width={17}
                          height={17}
                          className="ml-2 text-white transition-all duration-300 ease-in-out group-hover:translate-x-2"
                        />
                      </>
                    )}
                  </button>
                </div>
              )}

              {step === 2 && (
                <div className="">
                  <button
                    type="button"
                    disabled={isLoadVerifyOtp || inputs?.otp?.length !== 6}
                    onClick={handleVerifyOtp}
                    className="group flex items-center justify-center gap-2 w-full py-1 px-3 rounded-md primary_btn_bg text-white transition-all duration-300 ease-in-out disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    {isLoadVerifyOtp ? (
                      <>
                        {/* Spinner */}
                        <svg
                          className="animate-spin h-4 w-4"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a12 12 0 00-12 12h4z"
                          ></path>
                        </svg>
                        Verifying...
                      </>
                    ) : (
                      "Verify OTP"
                    )}
                  </button>
                </div>
              )}

              {step === 3 && (
                <div className="">
                  <button
                    type="button"
                    disabled={isLoadResetPwd}
                    onClick={handleResetPwd}
                    className="group flex items-center justify-center gap-2 w-full py-1 px-3 rounded-md primary_btn_bg text-white transition-all duration-300 ease-in-out disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    {isLoadResetPwd ? (
                      <>
                        {/* Spinner */}
                        <svg
                          className="animate-spin h-4 w-4"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a12 12 0 00-12 12h4z"
                          ></path>
                        </svg>
                        Resetting...
                      </>
                    ) : (
                      "Reset Password"
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeForgot;
